import {Injectable} from '@angular/core';
import {ApplicationInsights, IExceptionTelemetry} from '@microsoft/applicationinsights-web';
import {Router, NavigationEnd} from '@angular/router';
import {EnvService} from '../../env.service';
import {filter} from 'rxjs/operators';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightsService {
  private appInsights: ApplicationInsights;

  constructor(private router: Router,
              private userService: UserService,
              private env: EnvService) {

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.env.appInsightsKey
      }
    });

    this.appInsights.loadAppInsights();
    this.loadCustomTelemetryProperties();
    this.createRouterSubscription();

    this.setUserId(this.userService.getCurrentUserName());
  }

  setUserId(username: string) {
    this.appInsights.clearAuthenticatedUserContext();
    this.appInsights.setAuthenticatedUserContext(username);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri});
  }

  logException(error: Error) {
    const exception: IExceptionTelemetry = {
      exception : error
    };
    this.appInsights.trackException(exception);
  }

  private loadCustomTelemetryProperties() {
    this.appInsights.addTelemetryInitializer(envelope => {
        const item = envelope.baseData;
        item.properties = item.properties || {};
        item.properties.ApplicationPlatform = 'WEB';
        item.properties.ApplicationName = 'ProduceIT-Fusion-UI';
      }
    );
  }

  private createRouterSubscription() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.logPageView(null, event.urlAfterRedirects);
    });
  }
}
